const state = {
  confirmDialog: false,
  message: '',
  title: '',
  type: '',
  callback: null,
  messageForm: null,
  listaLink: {lista:[], show: false},
  btConfirm: { name: 'Ok', show: true, color: 'primary' },
  btCancel: { name: 'Cancelar', show: false },
  btExtra: { name: '', show: false },
  textForm: { label: "placeholder", show: false},
  selectMenu: { label: "placeholder", show: false}
}
const mutations = {
  showConfirmMessage: (state, opts) => {
    state.message = opts.message
    state.title = opts.title
    state.callback = opts.callback
    state.messageForm = opts.messageForm
    state.type = opts.type
    state.btConfirm = opts.btConfirm ? opts.btConfirm : { name: 'Ok', show: true, color: 'primary' },
    state.btConfirm.color = opts.btConfirm.color ? opts.btConfirm.color : 'primary'
    state.btCancel = opts.btCancel ? opts.btCancel : { name: 'Cancelar', show: false },
    state.btExtra = opts.btExtra ? opts.btExtra : { name: '', show: false },
    state.listaLink = opts.listaLink ? opts.listaLink : {lista:[], show: false},
    state.textForm = opts.textForm ? opts.textForm :  { label: "placeholder", show: false}
    state.selectMenu = opts.selectMenu ? opts.selectMenu :  { label: "placeholder", show: false}
    state.selectMenuForm = opts.selectMenuForm
    state.maxLengthItem = opts.maxLengthItem
    state.confirmDialog = true
  },
  closeConfirmMessage: (state) => {
    state.confirmDialog = false
  }
}
export default {
  namespaced: true,
  root: true,
  state,
  mutations
}
